const ZERO_SIZE_PATTERN = /^[-+]?0+(?:[.,]0+)?$/;

export const normalizeProductSizeForDisplay = (size: string | null | undefined): string => {
    const trimmedSize = (size || '').trim();
    if (!trimmedSize) {
        return '';
    }

    const isZeroSize = ZERO_SIZE_PATTERN.test(trimmedSize);

    return isZeroSize ? '' : trimmedSize;
};

export const formatProductDropdownInfo = (
    sku: string | null | undefined,
    size: string | null | undefined,
    brandName: string | null | undefined,
): string => {
    const normalizedSku = (sku || '').trim();
    const normalizedSize = normalizeProductSizeForDisplay(size);
    const normalizedBrandName = brandName?.trim() || '';

    const articleAndSize = normalizedSku
        ? normalizedSize
            ? `${normalizedSku} / ${normalizedSize}`
            : normalizedSku
        : normalizedSize;

    if (!normalizedBrandName) {
        return articleAndSize;
    }

    if (!articleAndSize) {
        return normalizedBrandName;
    }

    return `${articleAndSize}  - ${normalizedBrandName}`;
};

export const formatProductGroupDropdownInfo = (productCount: number, brandName: string | null | undefined): string => {
    const normalizedBrandName = brandName?.trim() || '';
    const normalizedCount = Number.isFinite(productCount) ? Math.max(0, Math.floor(productCount)) : 0;
    const countLabel = `${normalizedCount} товар${normalizedCount === 1 ? '' : normalizedCount < 5 ? 'а' : 'ов'}`;

    if (!normalizedBrandName) {
        return countLabel;
    }

    return `${countLabel}  - ${normalizedBrandName}`;
};
